import React from "react";
import { connect } from "react-redux";
import { AutoDismissibleAlert } from "./DismissibleAlerts";
import AlertService from "../../services/AlertService";

class ErrorAlerts extends React.Component {
  renderAlerts() {
    return this.props.alerts.map(alert => {
      return (
        <div key={alert.id}>
          <AutoDismissibleAlert
            variant="danger"
            alert={alert}
            onClick={() => AlertService.removeErrorAlert(alert.id)}
          />
        </div>
      );
    });
  }

  render() {
    if (this.props.alerts.length > 0) {
      return <div className="sticky">{this.renderAlerts()}</div>;
    }
    return null;
  }
}

const mapStateToProps = state => {
  return { alerts: state.alerts.errorAlerts };
};

export default connect(
  mapStateToProps,
  {}
)(ErrorAlerts);
